<template>
    <div>
        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-2">
                        <az-input 
                            type="checkbox-group"
                            label="Própria"
                            v-model="filtro.interno" />
                    </div>
                    <div class="col col-12 col-md-5">
                        <az-input   
                            type="select"
                            :optionsList="$util.unidades_com_tags(false, true)"
                            optionsData="id_unidade_operacao"
                            placeholder="Unidades..."
                            v-model="filtro.id_unidade_operacao">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <button class="btn btn-outline-primary" type="button" id="button-addon1" @click="load(false)">
                                        <i class="fas fa-sync-alt fa-fw"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-5">
                        <az-input 
                            placeholder="Hospital..."
                            icon="fas fa-clinic-medical fa-fw"
                            type="select"
                            optionsMode="aql"
                            service="centro_cirurgicos.index"
                            optionsData="id_centro_cirurgico" 
                            optionsDisplay="st_centro_cirurgico"
                            :optionsParm="{ ativos: true }"
                            v-if="!filtro.interno"
                            v-model="filtro.id_centro_cirurgico"  />

                        <az-input 
                            placeholder="Unidade de Internação..."
                            icon="fa-solid fa-bed fa-fw"
                            type="select"
                            optionsMode="aql"
                            :optionsName="'centro_custos.index.leito.' + filtro.id_unidade_operacao"
                            service="centro_custos.index"
                            optionsData="id_centro_custo" 
                            optionsDisplay="search"
                            :optionsParm="{ 
                                ativos: true,
                                id_unidade_operacao: filtro.id_unidade_operacao,
                                leitos: true, 
                            }"
                            v-else
                            v-model="filtro.id_centro_custo"  />
                    </div>
                </div>

                <div class="form-row mt-2">
                    <div class="col col-12">
                        <az-input icon="fa fa-search fa-fw" v-model="filtro.search">
                            <template v-slot:buttonposb>
                                <div class="input-group-append" v-if="false && filtro.interno">
                                    <button class="btn btn-outline-primary" type="button" id="button-addon1" @click="incluir()" title="Registrar Admissão">
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                    </button>
                                    <button class="btn btn-outline-primary" type="button" id="button-addon1" @click="agendados()" title="Registrar Admissão de Paciente Agendado">
                                        <i class="fa fa-calendar-plus-o" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>
                </div>
            </div>
        </div>

        <div class="progress mt-1 mb-2">
            <div class="indeterminate" v-if="$store.state.loading && lista.length"></div>
            <div class="determinate" v-else></div>
        </div>

        <az-empty-state 
            v-if="!lista.length" 
            icon="fa-solid fa-bed" 
            msg="Nenhum leito identificado." />

        <div v-else>
            <div v-if="dados.por_status">
                <div class="card">
                    <div class="card-header d-flex justify-content-between" v-if="dados.centro_custo">
                        <div>{{ dados.centro_custo.search }}</div>
                        <div>{{ dados.lista.length }}</div>
                    </div>
                    <ul class="list-group">
                        <li class="list-group-item d-flex justify-content-between" 
                            :class="'list-group-item-' + status.status_leito.color"
                            v-for="(status, isx) in dados.por_status" :key="isx">
                            <div>{{ status.status_leito.msg }}</div>
                            <div>
                                <span class="badge badge-light mr-3">
                                    {{ status.perc }}%
                                </span>

                                {{ status.qtde }}
                            </div>        
                        </li>
                    </ul>
                </div>
            </div>

            <div class="card carde mb-2 w3-animate-opacity" v-for="(leito, ilx) in lista" :key="ilx">
                <div class="card-body py-1 px-2">
                    <div class="row">
                        <div class="col col-12 col-md-1 d-flex flex-column">
                            <span class="badge" :class="'badge-' + leito.status_leito.color" v-if="leito.status_leito">
                                {{ leito.status_leito.msg }}
                            </span>
                        </div>
                        <div class="col col-12 col-md-3">
                            <div class="small text-muted">
                                {{ leito.centro_custo.unidade_operacao.st_nome }}
                            </div>
                            <div class="text-muted">
                                {{ leito.centro_custo.st_nome }}
                            </div>
                            <div class="font-weight-bold">
                                {{ leito.st_local }}
                            </div>
                        </div>
                        <div class="col col-12 col-md-4">
                            <template v-if="leito.internado">
                                <celula-dados-paciente :hor="{ marcacao: { 
                                        plano: leito.internado.plano,
                                        paciente: leito.internado.paciente, 
                                    }
                                }" />
                            </template>
                        </div>
                        <div class="col col-12 col-md-4 d-flex justify-content-between" v-if="leito.internado">
                            <div>
                                <div>
                                    {{ $util.getFormatDate(leito.internado.dt_admissao) }}
                                    {{ leito.internado.st_hora_admissao }}
                                </div>
                                <div class="small text-muted" v-if="leito.internado.st_motivo">
                                    {{ leito.internado.st_motivo }}
                                </div>
                                <div v-if="leito.internado.js_classes && leito.internado.js_classes.length">
                                    <a href="#" @click.prevent="filtrar(classe)" v-for="(classe, icx) in leito.internado.js_classes" :key="icx">
                                        <span class="badge badge-success mr-1">
                                            {{ classe }}
                                        </span>
                                    </a>
                                </div>
                            </div>

                            <!-- Menu de opções -->
                            <div class="dropleft d-flex align-items-center justify-content-center order-1 order-md-2">
                                <a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown"
                                    aria-haspopup="true" aria-expanded="false">
                                    <i class="fas fa-ellipsis-v"></i>
                                </a>
                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <button class="dropdown-item" @click="transferir(leito)">
                                        Transferir
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <pre v-if="false">{{ dados }}</pre>

            <transferir-leito ref="transf" @refresh="load()" />
        </div>
    </div>
</template>

<script>
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import CelulaDadosPaciente from '../../shared/table/CelulaDadosPaciente.vue';
import TransferirLeito from './TransferirLeito.vue';

export default {
    data() { 
        return { 
            dados: null, 
            filtro: { 
                interno: true, 
                id_centro_cirurgico: "", 
                id_unidade_operacao: "",
                id_centro_custo: "", 
                search: "", 
            }
        }
    },

    components: { 
        AzInput,
        AzEmptyState, 
        CelulaDadosPaciente, 
        TransferirLeito,
    },

    computed: { 
        lista: function () { 
            if ( !this.dados )
                return [];

            let reg = this.$util.getregex(this.filtro.search);
            
            return this.dados.lista.filter (item => { 
                return ( !this.filtro.search || reg.test(JSON.stringify(item)) );
            });
        }
    },

    methods: { 
        transferir (leito) { 
            this.$refs.transf.transferir(leito.internado, leito);
        },

        filtrar(classe) { 
            if ( this.filtro.search == '\x22' + classe + '\x22' ) { 
                this.filtro.search = ''
            } else { 
                this.filtro.search = '\x22' + classe + '\x22'
            }
        },

        load() { 

            if ( this.filtro.id_unidade_operacao != this.$util.getCookie('id_unidade_operacao') ) { 
                this.$util.setCookie('id_unidade_operacao', this.filtro.id_unidade_operacao);
            }

            if ( this.filtro.id_centro_custo != this.$util.getCookie('int-cc') ) { 
                this.$util.setCookie('int-cc', this.filtro.id_centro_custo, 365);
            }

            this.$util.load(this, { 
                service: 'locals',
                parms: { 
                    ativos: true, 
                    leitos: true,
                    mapa_leitos: true,
                    ...this.filtro, 
                },
                loadTo: res => { 
                    this.dados = res;
                }
            });
        }
    },

    beforeMount () { 

        this.filtro.id_unidade_operacao = this.$util.getCookie('id_unidade_operacao'), 
        this.filtro.id_centro_custo = this.$util.getCookie('int-cc')
            ? this.$util.getCookie('int-cc')
            : "";
        
    },

    mounted() { 
        this.$store.commit("setBreadcrumb", [
            { name: "Internação", path: "/internacao/internados" },
            { name: "Visão Geral", path: "/internacao/visao" }
        ]);

        this.load();
    }
}
</script>

